import React, { useEffect, useRef } from 'react';
import { rubros } from '../../json/rubros';
import './rubros.css';
import { Link, useNavigate } from 'react-router-dom';

const Rubros = () => {
  const containerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    containerRef.current?.scrollTo(0, 0);
  }, []);

  const irARubrosHistoricos = () => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    containerRef.current?.scrollTo(0, 0);

    setTimeout(() => {
      navigate('RubrosHistoricos');
    }, 0);
  };

  return (
      <div ref={containerRef} className="container">
        <div className="row">
          <div className="rubros_titulo">
            <br />
            <h2>Articulo 69 Ley de Transparencia (48 Rubros)</h2>
          </div>

          {rubros.map((item, index) => (
              <Link
                  key={index}
                  to={item.url ? item.url : "DetalleRubro/" + item.nombre}
                  className="col-md-4 col-sm-6 col-12 rubro_enlace"
              >
                <div className="rubro_container">
                  <div className="rubro_icono">
                    <img
                        src={
                            "http://cdn.hidalgo.gob.mx/plantilla_secretarial/Rubros/PNG/" +
                            item.icono
                        }
                        alt=""
                    />
                  </div>
                  <h3>{item.nombre}</h3>
                </div>
              </Link>
          ))}

          {/* 👇 ESTE es el cambio importante */}
          <button
              onClick={irARubrosHistoricos}
              className="rubros_historicos"
              style={{ background: 'none', border: 'none', padding: 0 }}
          >
            Información Ejercicios Anteriores Art. 69 (48 Fracciones)
          </button>

        </div>
      </div>
  );
};

export default Rubros;
